export const RANKS = [
  { minPoints: 0,    key: 'rankBeginner',   color: '#6B7280', icon: '🌱' },
  { minPoints: 10,   key: 'rankViewer',      color: '#3B82F6', icon: '👀' },
  { minPoints: 50,   key: 'rankReviewer',    color: '#8B5CF6', icon: '✍️' },
  { minPoints: 150,  key: 'rankConnoisseur', color: '#F59E0B', icon: '🎬' },
  { minPoints: 400,  key: 'rankExpert',      color: '#EF4444', icon: '🏆' },
  { minPoints: 1000, key: 'rankCritic',      color: '#EC4899', icon: '⭐' },
];

export function getRank(points = 0) {
  for (let i = RANKS.length - 1; i >= 0; i--) {
    if (points >= RANKS[i].minPoints) return RANKS[i];
  }
  return RANKS[0];
}

export function getNextRank(points = 0) {
  const currentRank = getRank(points);
  const currentIndex = RANKS.indexOf(currentRank);
  if (currentIndex < RANKS.length - 1) return RANKS[currentIndex + 1];
  return null;
}

export function getRankProgress(points = 0) {
  const current = getRank(points);
  const next = getNextRank(points);
  if (!next) return 100;
  const range = next.minPoints - current.minPoints;
  const progress = points - current.minPoints;
  return Math.min(100, Math.round((progress / range) * 100));
}
